import { useEffect, useState } from "react";

interface TypewriterProps {
  enabled?: boolean;
  text: string;
  speed?: number;
}

function Typewriter({ text, speed = 50, enabled = true }: TypewriterProps) {
  const [typedText, setTypedText] = useState("");

  useEffect(() => {
    if (!enabled) {
      setTypedText(text);
      return;
    }
    setTypedText("");
    let currentIndex = 0;

    // Create a new interval only after resetting the text
    const interval = setInterval(() => {
      if (currentIndex < text.length) {
        // Use a functional update to ensure we're working with the latest state
        setTypedText(text.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(interval);
      }
    }, speed);

    // Cleanup interval on unmount or when text/speed changes
    return () => clearInterval(interval);
  }, [text, speed, enabled]); // Dependencies remain the same

  return typedText;
}

export default Typewriter;
